// extracted by mini-css-extract-plugin
module.exports = {"todoItem":"Todo_todoItem__3vO1K","todoButtons":"Todo_todoButtons__3MxGw","complete":"Todo_complete__oB8RB","uncomplete":"Todo_uncomplete__1WYqr","remove":"Todo_remove__HFEcj"};